'use strict';

var _ = require('lodash');
var ChartDashboardTooltipFormattersService = function ChartDashboardTooltipFormattersService($filter) {
  var TOOLTIP_FIELDS_MAP = require('../config/dashboard-tooltip-fields-config.json');
  var rmNumberFormat = $filter('rmNumberFormat');
  function isPercentageMode(presentationMode) {
    return presentationMode === 'percentage';
  }
  function isLoadFactor(metric) {
    return metric === 'loadFactor';
  }
  function isRefMode(mode) {
    return mode === 'LY' || mode === 'SEASONAL_AVG';
  }
  function getLabelSuffix(mode, metric) {
    switch (mode) {
      case 'LY':
        return 'LY';
      case 'SEASONAL_AVG':
        return (isLoadFactor(metric) ? 'Overbooking' : 'Demand') + ' Season Avg';
      default:
        return '';
    }
  }
  var tootlipFormatter = _.template(require('../templates/chart-dashboard-tooltip.html'));
  function getPercentageValues(data, config) {
    if (!config.changeField || !data[config.changeField]) {
      return {};
    }
    var percentageChange = data[config.changeField];
    return {
      changeValue: rmNumberFormat(Math.abs(percentageChange), 'NUMBER_SHORT'),
      isChangePositive: percentageChange > 0
    };
  }
  function getCssLabelData(data, config) {
    if (_.isString(config.labelCss)) {
      return config.labelCss;
    }
    if (_.isPlainObject(config.labelCss)) {
      var key = data.isChangePositive ? 'positive' : 'negative';
      return config.labelCss[key];
    }
  }
  function formatValue(data, fieldSettings, metric) {
    var format = isLoadFactor(metric) ? 'PERCENTAGE_SHORT' : 'NUMBER_DECIMAL';
    return rmNumberFormat(data[fieldSettings.field], format);
  }
  function buildEntry(data, fieldSettings, metric, labelSufix) {
    var tooltipEntry = {
      label: fieldSettings.label.replace('REF', labelSufix),
      value: formatValue(data, fieldSettings, metric)
    };
    _.extend(tooltipEntry, getPercentageValues(data, fieldSettings));
    tooltipEntry.labelCss = getCssLabelData(tooltipEntry, fieldSettings) || '';
    return tooltipEntry;
  }
  function transformTooltipData(data, aggregationMode, presentationMode, metric) {
    var mode = isRefMode(aggregationMode) ? 'REF' : aggregationMode;
    var labelSufix = getLabelSuffix(aggregationMode, metric);
    var fields = TOOLTIP_FIELDS_MAP[presentationMode][mode];
    var tooltipData = {
      label: data.tooltipTitle,
      mainCss: data.mainCss || '',
      isPercentageMode: isPercentageMode(presentationMode)
    };
    tooltipData.fieldsData = _.transform(fields, function (result, fieldSettings) {
      var tooltipEntry = buildEntry(data, fieldSettings, metric, labelSufix);
      result.push(tooltipEntry);
      return result;
    }, []);
    return tooltipData;
  }
  function getTooltip(params) {
    var tooltipData = transformTooltipData(params.data, params.aggregationMode, params.presentationMode, params.metric);
    return tootlipFormatter(tooltipData);
  }
  return {
    getTooltip: getTooltip
  };
};
ChartDashboardTooltipFormattersService.$inject = ['$filter'];
module.exports = ChartDashboardTooltipFormattersService;